import macIcon from '@getgo/chameleon-icons/dist/rebranded/apple-monochromatic.svg';
import winIcon from '@getgo/chameleon-icons/dist/rebranded/windows.svg';
import androidIcon from '@getgo/chameleon-icons/dist/rebranded/android.svg';
import { macDeviceIcon, winDeviceIcon, androidDeviceIcon, iosDeviceIcon } from './device-os-icons.js';

export default function getOS() {
  if (navigator.userAgent.includes('Macintosh')) {
    return 'mac';
  }
  if (navigator.userAgent.includes('Windows')) {
    return 'win';
  }
  if (navigator.userAgentData?.platform) {
    return navigator.userAgentData?.platform;
  }
  return null;
}

export function getOsIcon(osName) {
  if (isMac(osName)) {
    return macIcon;
  }

  if (isWin(osName)) {
    return winIcon;
  }

  if (isAndroid(osName)) {
    return androidIcon;
  }

  return null;
}

export function getOsFormattedName(osName) {
  if (isMac(osName)) {
    return 'macOS';
  }

  if (isWin(osName)) {
    return 'Windows';
  }

  if (isAndroid(osName)) {
    return 'Android';
  }

  if (isIos(osName)) {
    return 'iOS';
  }

  return null;
}


export function getDeviceIcon(osName) {
  if (isMac(osName)) {
    return macDeviceIcon;
  }

  if (isWin(osName)) {
    return winDeviceIcon;
  }

  if (isAndroid(osName)) {
    return androidDeviceIcon;
  }

  if (isIos(osName)) {
    return iosDeviceIcon;
  }

  return winDeviceIcon;
}

function isMac(osName) {
  return osName?.toLowerCase().startsWith('mac');
}

function isWin(osName) {
  return osName?.toLowerCase().includes('win') || osName?.toLowerCase().includes('server');
}

function isAndroid(osName) {
  return osName?.toLowerCase().includes('android');
}

function isIos(osName) {
  return osName?.toLowerCase().includes('ios');
}

/**
 *
 * @param {import('../types/adapted-device').AdaptedDevice} device
 * @returns {boolean}
 */
export const isSamsungDevice = device => !!device.systemManufacturer?.toLowerCase().includes('samsung');
